"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = exports.Input = exports.InputContainer = exports.AmountContainer = exports.Label = exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _input = require("@creditas-lab/input");

var _typography = require("@creditas-lab/typography");

var _GhostButton = require("../GhostButton");

const Container = _stylitas.styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 16px 0 12px 0;

  ${_styleUtilities.media.md`
    margin: 24px 0 0 0;
  `}
`;
exports.Container = Container;
const Label = (0, _stylitas.styled)(_typography.Typography)`
  margin-bottom: 4px;

  ${_styleUtilities.media.md`
    margin-bottom: 8px;
  `}
`;
exports.Label = Label;
const AmountContainer = _stylitas.styled.div`
  display: flex;
  flex-direction: column;
`;
exports.AmountContainer = AmountContainer;
const InputContainer = _stylitas.styled.div`
  display: flex;
  align-items: center;
`;
exports.InputContainer = InputContainer;

const inputStyled = ({
  theme
}) => (0, _stylitas.css)`
    ${_styleUtilities.typography['2xl'](theme)};

    opacity: 1;
    padding: 0 0 0 4px;

    ${_styleUtilities.media.md`
      ${_styleUtilities.typography['2xl'](theme)};
    `}

    &:disabled {
      color: ${theme.colorNeutral90};
      -webkit-text-fill-color: ${theme.colorNeutral90};
    }
  `;

const InputStyled = (0, _stylitas.styled)(_input.Input)`
  ${inputStyled};
`;
exports.Input = InputStyled;
const ToggleButton = (0, _stylitas.styled)(_GhostButton.GhostButton)`
  overflow-x: visible;
`;
exports.ToggleButton = ToggleButton;